export enum SnackbarNotificationKind {
    // these require some extra positioning
    alert
}
